import Form from '../models/Form';

export default function (form: Form) {
    return (form.submission_count() || '0') + (form.max_submissions() ? '/' + form.max_submissions() : '');
}
